import PricingService from './pricingService';

export { PricingService };
export default PricingService;
